/**
 * 以下を行うmixin
 *  システムオーナー情報を取得しstoreに入れる
 */
export const getSystemOwner = {
  created() {
    this.$store.dispatch('account/GET_SYSTEM_OWNER')
  },
}
